export default __webpack_public_path__ + "static/media/1.11113eac.jpg";